import { ServerlistItemUI } from './serverlistItemUI';
import { Server } from '../../units/server/server';
import { ServerAction } from '../interface';
import { Notification } from '../../notification/notfication';
import { Dialog } from '../../dialog/dialog';
import ServerUnit = Server.ServerUnit;
import ServerEvent = Server.ServerEventType;
import ServerStatus = Server.ServerStatus;
import ServerOptions = Server.ServerOptions;
import ServerVisibilityOption = Server.ServerVisibilityOption;
import IStateDetails = Server.IStateDetails;
import IStateEvent = Server.IStateEvent;
import VoiceServerQueryResponse = Server.VoiceServerQueryResponse;
import GameServerQueryResponse = Server.GameServerQueryResponse;
import ServerEventType = Server.ServerEventType;
import ServerType = Server.ServerType;
import ServerInterface = Server.ServerInterface;
import i18next from "i18next";

export class ServerlistItem {
    private serverId: number;
    private serviceId: number;
    private server: Server.ServerInterface;

    public constructor(private ui: ServerlistItemUI) {
        window.addEventListener(ServerEventType.GAMESERVERINITIALISED_EVENT, () => {
            this.serverId = ui.getServerId();
            this.serviceId = ui.getServiceId();
            this.server = ServerUnit.getServerByServiceId(this.serviceId);

            if (this.server !== null) {
                let option: ServerOptions = new Server.ServerOptions(true, 10000);
                option.visibiltyOption = new ServerVisibilityOption($(this.ui.base), true);
                this.server.options = option;

                /* only for gameservers not for voiceservers */
                if(this.server.type !== ServerType.VOICESERVER) {
                    this.server.stateEvent.addEventListener(ServerEvent.STATECHANGE_EVENT, stateEvent => {
                        this.handleStateChange(this.server, stateEvent);
                    });
                }

                this.server.options.queryEvent.addEventListener(ServerEvent.SERVERQUERY_EVENT, stateEvent => {
                    this.handleQueryChange(this.server, stateEvent);
                });
                ui.onAction((event: JQuery.ClickEvent) => this.handleAction(event))
            }
        });
    }

    private handleAction(event: JQuery.ClickEvent) {
        const url = (event.currentTarget as HTMLElement).dataset.actionUrl;
        let action: string = event.currentTarget.getAttribute('data-action');
        event.preventDefault();

        switch (action) {
            case ServerAction.Delete:
              new Dialog()
                .withTitle(i18next.t('general:non_special_texts.are_you_sure'))
                .withText(i18next.t('gameserver:delete.question'))
                .withConfirmButtonText(i18next.t('general:non_special_texts.delete'))
                .withCenteredContent()
                .withOnConfirm(() => {
                  this.server.delete(url).then((state: boolean) => {
                    if (state) {
                      new Notification(
                        'success',
                        i18next.t('gameserver:delete.notifications.delete_gameserver_success.title'),
                        i18next.t('gameserver:delete.notifications.delete_gameserver_success.text')
                      );
                      this.ui.destroy();
                    }
                  }, (error) => {
                    new Notification(
                      'danger',
                      i18next.t('gameserver:delete.notifications.delete_gameserver_error.title'),
                      i18next.t('gameserver:delete.notifications.delete_gameserver_error.text')
                    );
                  });
                })
                .withIcon('trash-alt')
                .render();
                break;

            case ServerAction.Restart:
                this.server
                    .restart(url)
                    .then((status: boolean) => {
                        new Notification(
                          'success',
                          i18next.t('gameserver:restart.notifications.restart_gameserver_success.title'),
                          i18next.t('gameserver:restart.notifications.restart_gameserver_success.text')
                        );
                    })
                    .catch((error) => {
                        new Notification(
                          'danger',
                          i18next.t('gameserver:restart.notifications.restart_gameserver_error.title'),
                          i18next.t('gameserver:restart.notifications.restart_gameserver_error.text')
                        );
                    });
                break;

            case ServerAction.Reinstall:
              new Dialog()
                .withTitle(i18next.t('general:non_special_texts.are_you_sure'))
                .withText(i18next.t('gameserver:reinstall.question'))
                .withConfirmButtonText(i18next.t('general:non_special_texts.confirm'))
                .withCenteredContent()
                .withOnConfirm(() => {
                  this.server.reinstall(url).then((state: boolean) => {
                    if (state) {
                      new Notification(
                        'success',
                        i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_success.title'),
                        i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_success.text')
                      );
                    }
                    else {
                      new Notification(
                        'danger',
                        i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.title'),
                        i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.text')
                      );
                    }
                  }, (error) => {
                    new Notification(
                      'danger',
                      i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.title'),
                      i18next.t('gameserver:reinstall.notifications.reinstall_gameserver_error.text')
                    );
                  });
                })
                .withIcon()
                .render();
                break;

            case ServerAction.Start:
                this.server
                    .start(url)
                    .then((status: boolean) => {
                        new Notification(
                          'success',
                          i18next.t('gameserver:start.notifications.start_gameserver_success.title'),
                          i18next.t('gameserver:start.notifications.start_gameserver_success.text')
                        );
                    })
                    .catch((error) => {
                        new Notification(
                          'danger',
                          i18next.t('gameserver:start.notifications.start_gameserver_error.title'),
                          i18next.t('gameserver:start.notifications.start_gameserver_error.text')
                        );
                    });
                break;

            case ServerAction.Stop:
                this.server
                    .stop(url)
                    .then((status: boolean) => {
                        new Notification(
                          'success',
                          i18next.t('gameserver:stop.notifications.stop_gameserver_success.title'),
                          i18next.t('gameserver:stop.notifications.stop_gameserver_success.text')
                        );
                    })
                    .catch((error) => {
                        new Notification(
                          'danger',
                          i18next.t('gameserver:stop.notifications.stop_gameserver_error.title'),
                          i18next.t('gameserver:stop.notifications.stop_gameserver_error.text')
                        );
                    });
                break;
        }
    }

  /**
   *
   * @param server
   * @param stateChange
   * @private
   */
    private handleStateChange(server : ServerInterface, stateChange: IStateEvent): any {
        let newStatus: ServerStatus = stateChange.newstate;
        let oldStatus: ServerStatus = stateChange.oldstate;
        let details: IStateDetails = stateChange.details;
        this.ui.updateStatus(oldStatus, newStatus);

        if (newStatus.stateId === ServerStatus.RUNNING.stateId) {
            this.ui.enableStop();
            this.ui.enableRestart();

            this.ui.disableStart();
            this.ui.disableReinstall();

            this.ui.hideInstall();
        }
        else if (newStatus.stateId === ServerStatus.STOPPED.stateId) {
            this.ui.enableStart();
            this.ui.enableReinstall();

            this.ui.disableRestart();
            this.ui.disableStop();

            this.ui.hideInstall();
        } else if (newStatus.stateId === ServerStatus.INSTALLING.stateId) {
            this.ui.disableRestart();
            this.ui.disableStart();
            this.ui.disableStop();
            this.ui.showInstall(details);
        }
    }


    private handleVoiceServerStatus(queryResponse: Server.VoiceServerQueryResponse)
    {
        if (queryResponse.state == 'online'){
            this.ui.updateVoiceStatus('stopped', 'running');
            this.ui.enableStop();
            this.ui.enableRestart();

            this.ui.disableStart();
            this.ui.disableReinstall();

            this.ui.hideInstall();
        }else if (queryResponse.state == 'offline') {
            this.ui.updateVoiceStatus('running', 'stopped');
            this.ui.enableStart();
            this.ui.enableReinstall();

            this.ui.disableRestart();
            this.ui.disableStop();

            this.ui.hideInstall();
        }
    }
    /**
     *
     * @param serverResponse {Promise<VoiceServerQueryResponse|GameServerQueryResponse>}
     */
    private handleQueryChange(server : ServerInterface, serverResponse: Promise<VoiceServerQueryResponse | GameServerQueryResponse>) {
        switch (this.server.type) {
            case Server.ServerType.GAMESERVER:
                let gameserverResponse: Promise<Server.GameServerQueryResponse>
                    = <Promise<GameServerQueryResponse>>serverResponse;

                gameserverResponse
                    .then((queryResponse: Server.GameServerQueryResponse) => {
                        let serverName: string = queryResponse.name;

                        if (serverName !== null && serverName.trim().length) {
                            this.ui.updateServername(queryResponse.name);
                        }

                        if (queryResponse.currentPlayers && queryResponse.maxPlayers) {
                            this.ui.updateActivePlayersSlot(queryResponse.currentPlayers.toString().concat(' / '));
                            this.ui.updateMaxPlayerSlot(queryResponse.maxPlayers.toString());
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                break;

            case Server.ServerType.VOICESERVER:
                let voiceserverResponse: Promise<Server.VoiceServerQueryResponse>
                    = <Promise<Server.VoiceServerQueryResponse>>serverResponse;

                voiceserverResponse
                    .then((queryResponse: Server.VoiceServerQueryResponse) => {
                        console.debug(queryResponse.online);
                        if (queryResponse.online) {
                            this.ui.updateActivePlayersSlot(queryResponse.online.toString().concat(' / '));

                        }
                        if (!queryResponse.online){
                            this.ui.updateActivePlayersSlot(" 0 ".concat(' / '));
                        }
                        this.handleVoiceServerStatus(queryResponse);
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                break;
        }
    }
}
